import request from '@/utils/http';
import { SRM } from '../../constant/constant.js';

// 申请记录-查询列表
export const getSupMipAudits = data => {
    return request({
        url: `${SRM}/supplierMipAudits`,
        method: 'post',
        data
    });
};

// 申请记录-重新提交
export const reSubmitFlow = data => {
    return request({
        url: `${SRM}/supplierGrabOrderInfo/reSubmitFlow`,
        method: 'post',
        data
    });
};

// 资质自检
export const validGrabOrder = data => {
    return request({
        url: `${SRM}/supplierGrabOrderInfo/validGrabOrder`,
        method: 'post',
        data
    });
};

// 提交审批
export const createFlow = data => {
    return request({
        url: `${SRM}/supplierGrabOrderInfo/createFlow`,
        method: 'post',
        data
    });
};
